import React from "react";

// @mui component:
import type { TableHeadProps } from "@mui/material/TableHead";
import XTableHead from "@mui/material/TableHead";

const TableHead: React.FC<TableHeadProps> = (props) => {
  return <XTableHead {...props}>{props.children}</XTableHead>;
};

export default TableHead;
